const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
let loaded = false;

export function initMetaPixel() {
  if (!PIXEL_ID || loaded || typeof window === "undefined") return false;
  if (window.fbq) return true;
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", PIXEL_ID);
  loaded = true;
  return true;
}

export function track(event, params = {}) {
  if (!PIXEL_ID) return;
  initMetaPixel();
  if (window.fbq) window.fbq("track", event, params);
}

export const meta = {
  pageView: () => track("PageView"),
  lead: (p = {}) => track("Lead", p),
  initiateCheckout: (p = {}) => track("InitiateCheckout", p),
  purchase: (p) => track("Purchase", p),
  contact: (p = {}) => track("Contact", p),
};
